/**
 * 手机号码
 * @param {*} s
 */
export function isPhone(s) {
  return /^1[3456789]\d{9}$/.test(s)
}
